/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const FulfillmentMethod = {
  BillOrDebtPayment: "bill-or-debt-payment",
  DigitalContent: "digital-content",
  Donation: "donation",
  InPersonService: "in-person-service",
  LocalPickupOrDelivery: "local-pickup-or-delivery",
  Other: "other",
  RemoteService: "remote-service",
  ShippedPhysicalGoods: "shipped-physical-goods",
  SubscriptionOrMembership: "subscription-or-membership",
} as const;
export type FulfillmentMethod = ClosedEnum<typeof FulfillmentMethod>;

/** @internal */
export const FulfillmentMethod$inboundSchema: z.ZodNativeEnum<
  typeof FulfillmentMethod
> = z.nativeEnum(FulfillmentMethod);
/** @internal */
export const FulfillmentMethod$outboundSchema: z.ZodNativeEnum<
  typeof FulfillmentMethod
> = FulfillmentMethod$inboundSchema;
